<template>
  <div
    class="relative w-full overflow-hidden rounded-lg text-center"
    data-test="gallery-desktop-main-panel"
    data-testid="gallery-desktop-main-panel"
  >
    <slot name="default" />
  </div>
</template>
